<template>
    <div v-if="details" class="holiday-details">
        <div class="holiday">
            <div class="holiday-gallery">
                <img
                    id="main-img"
                    class="main-img"
                    :src="require(`@/assets/${imageDetails.src}`)"
                    alt="holiday"
                />
                <div class="thumbnail-container">
                    <img
                        v-for="thumb in details.thumbnail"
                        :key="thumb.id"
                        :src="require(`@/assets/${thumb.src}`)"
                        alt="thumb.id"
                        @click="handler(thumb.imgId)"
                    />
                </div>
            </div>
            <div class="inner-container">
                <div class="inner-text">
                    <div class="title-div">
                        <h1>{{ details.hotel }}</h1>
                    </div>
                    <h2>{{ details.city }}</h2>
                    <h3>{{ details.country }}</h3>
                    <p>
                        {{ details.duration }} night stay for £{{
                            details.price
                        }}.00pp
                    </p>
                    <p>Flying: {{ details.date }}</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <p>Loading Details...</p>
    </div>
</template>

<script>
    class Holiday {
        constructor(
            id,
            hotel,
            country,
            city,
            duration,
            date,
            price,
            image,
            thumbnail
        ) {
            this.id = id;
            this.hotel = hotel;
            this.country = country;
            this.city = city;
            this.duration = duration;
            this.date = date;
            this.price = price;
            this.image = image;
            this.thumbnail = thumbnail;
        }
    }
    export default {
        props: ["id"],
        data() {
            return {
                details: null,
                imageDetails: null,
                holidayList: [
                    new Holiday(
                        1,
                        "Parque Hotel",
                        "Tenerife",
                        "Puerto De La Cruz",
                        14,
                        "08.06.2022",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                        ]
                    ),
                    new Holiday(
                        2,
                        "Hotel Catalonia",
                        "Majorca",
                        "Alcudia",
                        4,
                        "23.04.2021",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                        ]
                    ),
                    new Holiday(
                        3,
                        "Playa Bonito",
                        "Gran Canaria",
                        "Playa Del Ingles",
                        4,
                        "23.04.2021",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                        ]
                    ),
                    new Holiday(
                        4,
                        "Parque Hotel",
                        "Tenerife",
                        "Puerto De La Cruz",
                        14,
                        "08.06.2022",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                        ]
                    ),
                    new Holiday(
                        5,
                        "Hotel Catalonia",
                        "Majorca",
                        "Alcudia",
                        4,
                        "23.04.2021",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                        ]
                    ),
                    new Holiday(
                        6,
                        "Playa Bonito",
                        "Gran Canaria",
                        "Playa Del Ingles",
                        4,
                        "23.04.2021",
                        429,
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-3.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-1.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-2.jpg",
                            },
                        ],
                        [
                            {
                                imgId: 1,
                                alt: "holiday image",
                                src: "holiday-3-thumb.jpg",
                            },
                            {
                                imgId: 2,
                                alt: "holiday image",
                                src: "holiday-1-thumb.jpg",
                            },
                            {
                                imgId: 3,
                                alt: "holiday image",
                                src: "holiday-2-thumb.jpg",
                            },
                        ]
                    ),
                ],
            };
        },
        methods: {
            handler(imgId) {
                this.imageDetails = this.details.image.find(
                    (element) => element.imgId == imgId
                );
            },
        },
        mounted() {
            // fetch("http://localhost:3000/holidays/" + this.id)
            //     .then((res) => res.json())
            //     .then(
            //         (data) => (
            //             (this.details = data),
            //             (this.imageDetails = data.image[0])
            //         )
            //     )
            //     .catch((err) => console.log(err.message));

            this.holidayList.forEach((holiday) => {
                console.log(
                    "this.id: " + this.id + " | holiday id: " + holiday.id
                );
                if (holiday.id == this.id) {
                    this.details = holiday;
                    this.imageDetails = holiday.image[0];
                    console.log(holiday);
                }
            });

            console.log(this.details);
            console.log(this.imageDetails);
        },
    };
</script>

<style lang="scss" scoped>
    .holiday-details {
        width: 100%;
        height: 100%;
        padding: 110px 0 0 0;
    }
    .holiday {
        width: 90%;
        margin: auto;
        border-radius: 10px;
        display: flex;
        justify-content: center;
    }

    .holiday-gallery {
        height: auto;
        width: 70%;
        background-position: center;
        background-size: cover;
        border-radius: 10px 0 0 10px;

        .main-img {
            height: auto;
            width: 100%;
            border-radius: 10px;
            border: 12px solid rgba(255, 255, 255, 0.9);
            object-fit: cover;
        }
    }

    .thumbnail-container {
        background-color: rgba(255, 255, 255, 0.9);
        width: 100%;
        height: 128px;
        margin: 8px 0 0 0;
        border-radius: 10px;
        display: flex;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        border: 8px solid white;

        img {
            height: 100%;
            width: auto;
            padding: 0 2px;
            flex: 0 0 auto;
        }
    }

    .inner-container {
        width: 30%;
        color: black;
        border-radius: 10px;
        margin: 0 0 0 8px;
        background-color: rgba(255, 255, 255, 0.9);
    }
    .title-div {
        background-color: rgba(73, 29, 123, 0.8);
        width: 100%;
        border-radius: 10px 10px 0 0;
        text-align: center;
        color: white;
        h1 {
            font-size: 3em;
        }
    }
    .inner-text {
        width: 100%;
        height: 220px;
        text-align: center;
        h2 {
            padding: 6px;
            font-size: 2em;
        }
        h3 {
            padding: 6px;
            font-size: 1.5em;
        }
        p {
            padding: 6px;
            font-size: 1.1em;
        }
    }
</style>
